<template>
  <div>
    <el-dialog title="重置支付密码" :visible.sync="isForgetPayPassPayPass" width="650px" :before-close="close" :close-on-click-modal="false">
      <div class="link-top"></div>
      <el-form :inline="true" label-width="100px" class="center">
        <div v-if="passwordHidden">
          <el-row style="width: 400px;">
            <el-form-item label="手机号码：" required>
              <el-input v-model="phoneNum" type="number" disabled class="input"></el-input>
            </el-form-item>
            <el-form-item label="验证码：" required>
              <el-input v-model="smsCode" @input="checkReg" placeholder="请输入短信验证码" class='code'></el-input>
              <span @click="getCode" v-if="!countDownTime" :disabled="codeCount > 5" class="code-btn">获取验证码</span>
              <div v-else style="color:#908E8E;"> {{'已发送(' + countDownTime +'s)'}}</div>
            </el-form-item>
            <el-form-item label="支付密码：" required>
              <el-input v-model='setPass' :type="isDesen ? 'password' : ''" placeholder='输入6位数字' class="input" @input="checkPass(setPass, 'setPass')"></el-input>
              <div @click="select" class="tips">
                <img src="@/assets/password_hide.png" alt="" class="password" v-if="isDesen">
                <img src="@/assets/password_visual.png" alt="" class="password" v-if="!isDesen">
              </div>
            </el-form-item>
            <el-form-item label="再次输入：" required>
              <el-input v-model='confirmPass' :type="isDesenb ? 'password' : ''" placeholder="输入6位数字" class="input" @input="checkPass(confirmPass, 'confirmPass')"></el-input>
              <div @click="selectb" class="tips">
                <img src="@/assets/password_hide.png" alt="" class="password" v-if="isDesenb">
                <img src="@/assets/password_visual.png" alt="" class="password" v-if="!isDesenb">
              </div>
            </el-form-item>
            <el-button class="sure" @click="setPayPass">确定</el-button>
          </el-row>
        </div>
        <div style="text-align: center" v-else>
          <img :src="success" alt="">
          <div class='passSuss' style="color: #333;">重置支付密码成功</div>
          <el-button class="sure-l" @click="sure">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import CryptoJS from 'crypto-js'
import api from '@/api'
import visualImg from '@/assets/password_visual.png'
import hideImg from '@/assets/password_hide.png'
import success from '@/assets/success.png'
export default {
  name: 'forget-pass',
  props: {
    editType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visualImg: visualImg,
      hideImg: hideImg,
      success: success,
      // 密码
      passwordReg: /^\d{6}$/,
      isForgetPayPassPayPass: true,
      passwordHidden: true,

      // 手机号码
      phoneNum: Cookie.getJSON('AppUserInfo').mobile,
      // 验证码倒计时
      countDownTime: null,
      // 记录获取验证码的次数 超过5次值接签约失败
      codeCount: 0,
      // 验证码
      smsCode: '',
      // 设置交易密码
      setPass: '',
      confirmPass: '',
      encPass: '',
      // 屏蔽快速点击
      flag: true,

      // 密码脱敏显示
      isDesen: true,
      isDesenb: true,

      btnOff: true
    }
  },

  watch: {
    'smsCode': function () {
      if (this.btnOff) {
        this.btnOff = false
        this.smsCode = ''
        this.setPass = ''
        this.confirmPass = ''
      }
    }
  },
  methods: {
    // 密码脱敏显示
    select () {
      this.isDesen = !this.isDesen
    },

    // 密码脱敏显示
    selectb () {
      this.isDesenb = !this.isDesenb
    },

    // 关闭忘记密码弹窗
    close () {
      this.$emit('closeMain', false)
    },

    // 获取验证码
    getCode () {
      if (this.flag) {
        this.flag = false
        api.myAccount.sendOutCode({ phone: this.phoneNum, bizType: 'chkPayPwd' }).then((res) => {
          this.$message.success('成功')
          this.countDownTime = 60
          let timer = setInterval(() => {
            this.countDownTime--
            if (this.countDownTime === 0) {
              clearInterval(timer)
              this.flag = true
            }
          }, 1000)
        }).catch((err) => {
          setTimeout(() => {
            this.flag = true
          }, 5000)
          this.$message.error(err)
        })
      }
    },

    // 数字过滤
    checkReg (e) {
      this.smsCode = e.replace(/[^\d]/g, '')
    },

    // 判断是否是数字
    checkPass (v, k) {
      if (!isNaN(v)) {
        this[k] = v
      } else {
        this[k] = ''
      }
    },

    // 设置支付密码
    setPayPass () {
      if (this.smsCode === '') {
        this.$message.error('请输入验证码')
      } else if (this.setPass === '') {
        this.$message.error('请输入支付密码')
      } else if (this.confirmPass === '') {
        this.$message.error('请再次输入支付密码')
      } else if (this.setPass !== this.confirmPass) {
        this.$message.error('两次输入的密码不一致')
      } else if (!this.passwordReg.test(this.setPass)) {
        this.$message.error('请设置6位数字')
      } else {
        this.encPass = this.encryptByAes(this.setPass)
        if (this.editType === '2') {
          // 忘记密码设置
          let param = {
            oldPayPwd: this.encPass,
            newPayPwd: this.encPass,
            smsCode: this.smsCode,
            editType: '2',
            aesKey: 'APP7apecSQznwPWD',
            aesIv: '307znw65426apecb'
          }
          api.myAccount.modifyPayPwd(param).then((res) => {
            if (res.errorCode) {
              this.$message.error('网络异常，请稍后再试')
            } else {
              this.passwordHidden = false
            }
          }).catch((err) => {
            this.$message.error(err)
            // this.$emit('closeMain', false)
          })
        } else {
          // 设置支付密码
          let param = {
            userId: this.transferData.userId,
            newPayPwd: this.encPass,
            aesKey: 'APP7apecSQznwPWD',
            aesIv: '307znw65426apecb'
          }
          api.myAccount.setPayPwd(param).then((res) => {
            this.$message.success('设置成功')
            this.$emit('closeMain', false)
            this.isForgetPayPassPayPass = false
          }).catch((err) => {
            // this.$emit('closeMain', false)
            this.$message.error(err)
          })
        }
      }
    },

    // 密码加密
    encryptByAes (psw) {
      let key = CryptoJS.enc.Utf8.parse('APP7apecSQznwPWD') // 秘钥
      let iv = CryptoJS.enc.Utf8.parse('307znw65426apecb') // 偏移量
      let srcs = CryptoJS.enc.Utf8.parse(psw)
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      return encrypted.ciphertext.toString().toUpperCase()
    },

    // 设置成功关闭弹窗
    sure () {
      this.isForgetPayPassPayPass = false
      this.$emit('closeMain', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.password {
  width: 22px;
  height: 10px;
  float: left;
}
.tips {
  position: absolute;
  top: 16px;
  left: 230px;
  width: 25px;
  height: 25px;
}
.link-top {
  width: 100%;
  height: 1px;
  border-top: solid #f8bd47 1px;
  margin-bottom: 30px;
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.input {
  width: 260px;
  height: 30px;
  line-height: 30px;
}
.code {
  width: 168px;
  height: 30px;
  line-height: 30px;
}
.code-btn {
  cursor: pointer;
  display: inline-block;
  height: 37px;
  width: 88px;
  font-size: 12px;
  text-align: center;
  border: 1px solid #ccc;
  background: #f5f5f5;
  border-radius: 3px;
  line-height: 37px;
  margin-left: 8px;
}
.sure {
  margin: 0 0 0 100px;
  width: 260px;
  background: #f8bd47;
  color: #fff;
}
.sure-l {
  width: 260px;
  background: #f8bd47;
  color: #fff;
  margin-top: 40px;
}
.passSuss {
  font-family: '微软雅黑';
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: rgba(51, 51, 51, 0.94);
  font-size: 14px;
  margin-top: 20px;
}
</style>
